import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { FlavorType } from 'src/app/products/interfaces/models';

import { CocktailSyrupProperties } from '@app/api/models';
import { SubformBaseWithSugarContentPropertiesComponent } from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-cocktail-syrup-properties-subform',
  styleUrls: ['./cocktail-syrup-properties-subform.component.scss'],
  templateUrl: './cocktail-syrup-properties-subform.component.html',
})
export class CocktailSyrupPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = false;
  DICT_PATH = 'PRODUCTS.COCKTAIL_SYRUP_PROPERTIES';

  flavorType = FlavorType;

  static buildForm(fb: FormBuilder, data?: CocktailSyrupProperties) {
    return fb.group({
      flavorTypes: [data?.flavorTypes, Validators.required],
      basedOnExtractAccordingToHungarianFoodCode: [
        data?.basedOnExtractAccordingToHungarianFoodCode,
      ],
      fruitPerVegetablesRatioLessThan50Percent: [
        data?.fruitPerVegetablesRatioLessThan50Percent,
      ],
      // build sugar content properties
      ...SubformBaseWithSugarContentPropertiesComponent.buildFields(data),
    });
  }
}
